import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import hotelsData from '../fakeData/hotelsData/hotelsData';
import Hotel from '../Hotel/Hotel';
import Map from '../Map/Map';

const Hotels = () => {
    const hotelData = [...hotelsData];
    return (
        <>
            <Container>
                <Row>
                    <Col xs={8}>
                        {
                            hotelData.map(hotel => <Hotel hotel={hotel} key={hotel.id} />)
                        }
                    </Col>
                    <Col xs={4}>
                        <Map />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Hotels;